import "firebase/analytics";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";
import { firebaseReducer } from "react-redux-firebase";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  createFirestoreInstance,
  firestoreReducer,
  getFirestore,
  reduxFirestore,
} from "redux-firestore";
import logger from "redux-logger";
import { persistReducer, persistStore } from "redux-persist";
import localStorage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import piattoReducer from "./reducers";
const middlewares = [thunk.withExtraArgument(getFirestore)];

// const fbConfig = {
//   apiKey: "AIzaSyBkvAMjYkt2C8-lccAhAgxEEKh3vSHDE24",
//   authDomain: "wine-n-dine-30dab.firebaseapp.com",
//   databaseURL: "https://wine-n-dine-30dab.firebaseio.com",
//   projectId: "wine-n-dine-30dab",
//   storageBucket: "wine-n-dine-30dab.appspot.com",
//   messagingSenderId: "369290895355",
//   appId: "1:369290895355:web:57fbf361ede1584e2cb55e",
//   measurementId: "G-B4MSQ4QRKD",
// };

const fbConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const rrfConfig = {
  userProfile: "VenueManagement",
  useFirestoreForProfile: true,
};
const persistConfig = {
  key: "root",
  storage: localStorage,
};
firebase.initializeApp(fbConfig);

firebase.firestore();
firebase.storage();
if (window.localStorage.getItem("cookie_consent") === "accepted") {
  firebase.analytics();
}

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  state: piattoReducer,
});
export const persistedReducer = persistReducer(persistConfig, rootReducer);
export const functions = firebase.functions();
if (process.env.NODE_ENV === "development") {
  middlewares.push(logger);
}

const composedEnhancers =
  process.env.NODE_ENV === "development"
    ? composeWithDevTools(applyMiddleware(...middlewares), reduxFirestore(firebase, fbConfig))
    : compose(applyMiddleware(...middlewares), reduxFirestore(firebase, fbConfig));

export const store = createStore(
  persistedReducer,
  composedEnhancers
);

export const persistor = persistStore(store);

export const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};

